import { TSpmParam, genSpmLink } from "tyrande";
import { isUndefinedOrEmpty } from "utils/string";
import { Platform, CommonRuntime } from "utils/runtime";
import { LinkTargetType } from "views/services/playground";

export const uatMHost = "m-kdev0-eechic.ezbuy.dev";
export const ustPCHost = "kdev0-eechic.ezbuy.dev";
export const onlineMHost = "mpro.eechic.com";
export const onlinePCHost = "pro.eechic.com";
export const preMHost = "pre-mpro.eechic.com";
export const prePCHost = "pre-pro.eechic.com";

export const getSite = (platform: Platform) => {
	let site = "1";
	if (platform === Platform.MWEB) {
		site = `${site}-2`;
	}
	return site;
};

export function genPrmLink(
	prm: { floor: string | number; position: string | number },
	runtime: Partial<CommonRuntime>,
	url: string = "",
): string {
	if (url === undefined || url === "") {
		return "";
	}
	if (url.startsWith("#") || url.match(/prm=(?=\d+\.)/)) {
		return url;
	}
	const postUrl = url;
	let { floor, position } = prm;

	floor = floor.toString();
	position = position.toString();

	// 1 固定  65表示 tights
	// PRD: https://www.tapd.cn/22265281/prong/stories/view/1122265281001032651

	const prmString = [getSite(runtime.platform), "65", floor, position]
		.filter((v) => !isUndefinedOrEmpty(v))
		.join(".");
	let startChat = "?";
	if (postUrl.includes("?")) {
		startChat = postUrl.endsWith("&") ? "" : "&";
	}
	return `${postUrl}${startChat}prm=${prmString}`;
}

/**
 * 作用: 替换url中的参数值
 * 返回值：修改好参数的url，默认需改当前页面的url中的参数，返回新的url
 */
export const replaceUrlParamVal = (
	paramName: string,
	replaceWith: string,
	url: string = window?.location?.href || "",
) => {
	let re = new RegExp(`(${paramName}=)([^&]*)`, "ig");
	const result = url.replace(re, `${paramName}=${replaceWith}`);
	re = null;
	return result;
};

/**
 * 针对ios 外跳问题，临时都处理为 - 取消外跳
 */

export const isLinkHasNewWindow = (runtime: CommonRuntime) => {
	if (runtime.isInApp && !runtime.userAgent?.match(/android/gi)) {
		return LinkTargetType.Self;
	}
	return LinkTargetType.Blank;
};

export function genEzspmLink(
	url: string = "",
	ezspmParams: Partial<TSpmParam>,
	runtime?: Partial<CommonRuntime>,
): string {
	if (url === undefined || url === "") {
		return "";
	}
	if (url.startsWith("#")) {
		return url;
	}
	if (!runtime?.isInApp && url.match(runtime?.hostname)) {
		const regx = new RegExp(`^http(s?)://${runtime.hostname}`);
		url = url.replace(regx, "");
	}

	// 1 固定  65表示 tights
	// PRD: https://www.tapd.cn/20269511/markdown_wikis/view/#1120269511001038872

	return genSpmLink({ ...ezspmParams, url } as TSpmParam & { url: string }, false);
}
